/*
# -----------------------------------------------------------------------------
# Component: callFuncAjaxMixin.js
# Author: cyy@pst.sg
# Created Date: 11-Dec-2020
# Comments: Responsible for calling function in ClmDoc
# -----------------------------------------------------------------------------
*/

import * as TableConst from '@/mixins/table'
import Vue from 'vue'
import { expandURI, filterQuery } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate } from '@/utils/date'

export const callFuncAjaxMixin = {
  props: {
  },
  data() {
    return {
      loading: false,
      submitting: false,
      totalItems: 0,
      findDocHdgList: [],
      findClmDocList: [],
      itemsList: [],
      interlist: [],
      menu: {},
      supportedFormat: [],
      dtoList: [],
      pagination: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      headers: [
        { text: 'Claim Document', align: 'left', value: 'docHdgDesc' },
        { text: 'Claimant No.', align: 'left', value: 'clmtNo' },
        { text: 'Claim Item', align: 'left', value: 'clmItem' },
        { text: 'Service Provider', align: 'left', value: 'inter' },
        { text: 'Tran Type 1', align: 'left', value: 'tranType1' },
        { text: 'Doc No.', align: 'left', value: 'docNo' },
        { text: 'Gen Date', align: 'left', value: 'genDate' },
        { text: 'Sent Date.', align: 'left', value: 'sentDate' },
        { text: 'Rec\d Date', align: 'left', value: 'recvDate' },
        TableConst.tableActionHeader
      ],
      labels: {
        polType: 'Policy Type',
        prtAckLtr: 'Print',
        documentNo: 'docNo input',
        docHdg: 'Claim Doc',
        clmtNo: 'Claimant No. / Claim Item',
        clmItem: 'Claim Item',
        inter: 'Service Provider',
        tranType1: 'Tran Type 1 / Doc No.',
        docNo: 'Doc No.',
        genDate: 'Generated Date',
        genBy: 'Generated By',
        sentDate: 'Sent Date',
        sentBy: 'Sent By',
        recvDate: 'Received Date',
        recvBy: 'Received By',
        genDoc: 'Generate Document',
        emailRecip: 'Email Recipient',
        smsRecip: 'SMS Recipient',
        emailAgt: 'Email Agent',
        smsAgt: 'SMS Agent',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      clmDocForm: {
        documentNo: '',
        docHdg: undefined,
        docHdgDesc: undefined,
        clmtNo: undefined,
        clmItem: undefined,
        clmtNoClmItem: undefined,
        inter: undefined,
        tranType1: undefined,
        docNo: undefined,
        tranType1DocNo: undefined,
        genDate: undefined,
        genBy: undefined,
        sentDate: undefined,
        sentBy: undefined,
        recvDate: undefined,
        genDoc: false,
        emailRecip: false,
        smsRecip: false,
        emailAgt: false,
        smsAgt: false,
        createdBy: undefined,
        createdDate: undefined,
        modifiedBy: undefined,
        modifiedDate: undefined,
        tranId: undefined,
        clmNo: undefined,
        clmResCat: undefined,
        branch: undefined,
        recvBy: undefined,
        delDoc: undefined
      },
      form: {
        docHdg: undefined,
        clmNo: undefined,
        docNo: '',
        clmtNo: 0,
        clmItem: 0,
        serProvider: '',
        clmResCat: '',
        branch: '',
        tranType1: '',
        fund: ''
      },
      clmtDetForm: {
        clmNo: undefined,
        clmtNo: undefined,
        clmtName: undefined,
        addr1: undefined,
        addr2: undefined,
        addr3: undefined,
        addr4: undefined,
        postCode: undefined,
        email: undefined,
        mobile: undefined
      },
      clmMasterList: [],
      docNoInput: [
        { docNo: '620' },
        { docNo: '622' }
      ],
      clmDocNoList: [
        { code: '620', value: 'Claims Acknowledgement Letter', codeValue: '620 - Claims Acknowledgement Letter' },
        { code: '622', value: 'Documentation Request Letter', codeValue: '622 - Documentation Request Letter' },
        { code: '623', value: 'Service Provider Appointment Letter', codeValue: '623 - Service Provider Appointment Letter' },
        { code: '624', value: 'Offer Settlement Letter', codeValue: '624 - Offer Settlement Letter' },
        { code: '625', value: 'Discharge Voucher', codeValue: '625 - Discharge Voucher' },
        { code: '626', value: 'Subrogation Form', codeValue: '626 - Subrogation Form' },
        { code: '627', value: 'Counter Guarantee Letter', codeValue: '627 - Counter Guarantee Letter' },
        { code: '628', value: 'Third Party Claimant PDPA', codeValue: '628 - Third Party Claimant PDPA' }
      ],
      promptRemove: false,
      getEmail: '',
      getMobile: '',
      getAgentEmail: '',
      getAgentSms: '',
      selected: {
        tranId: null,
        docHdg: null,
        docHdgDesc: null,
        clmNo: null,
        clmtNo: null,
        clmItem: null,
        inter: null,
        tranType1: null,
        docNo: null
      },
      liabilityList: [
        { label: '100 - 100%', value: '100' },
        { label: '75 - 75%', value: '75' },
        { label: '50 - 50%', value: '50' },
        { label: 'TBD - To be determined', value: 'TBD' }
      ]
    }
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    getMenu() {
      return this.$store.state.claims.claimDetail.menu
    },
    claimantNo() {
      for (let clmt of this.commonInfo.claimants) {
        if (clmt.clmNo === this.commonInfo.clmNo) {
          return clmt.clmtNo
        }
      }
      return {}
    }
  },
  methods: {
    async getRptMenu() {
      try {
        const apiURI2 = this.getMenu.initClmAckn
        const result2 = await this.$http.get(apiURI2)
        if (result2.data) {
          const { data } = result2.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result2.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    // find docHdg
    async findDocHdg(dt) {
      const apiURI = this.getMenu.findDocumentHeading
      if (apiURI) {
        try {
          for (var i = 0; i < dt.length; i++) {
            const expand = {
              docNo: dt[i].docNo,
              polType: this.commonInfo.polType
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              const convertList = {
                docNo: data.docNo,
                polType: data.polType,
                result: data.getResult
              }
              this.findDocHdgList.push(convertList)
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          return false
        }
        return true
      }
    },
    // find docHdg for 628
    async find628DocHdg() {
      const apiURI = this.getMenu.findDocumentHeading
      if (apiURI) {
        try {
          const expand = {
            docNo: '628',
            polType: this.commonInfo.polType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            const convertList = {
              docNo: data.docNo,
              polType: data.polType,
              result: data.getResult
            }
            this.findDocHdgList.push(convertList)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          return false
        }
        return true
      }
    },
    // find clmDoc
    async findClaimDocument(dat) {
      const apiURI = this.getMenu.findClaimDocuments
      if (apiURI) {
        try {
          for (var j = 0; j < dat.length; j++) {
            if (dat[j].result === true) {
              const expand = {
                docHdg: dat[j].docNo,
                clmNo: this.commonInfo.clmNo,
                polType: dat[j].polType,
                clmtNo: this.form.clmtNo,
                clmItem: this.form.clmItem,
                serProvider: this.form.serProvider,
                clmResCat: this.form.clmResCat,
                branch: this.form.branch,
                tranType1: this.form.tranType1,
                docNo: this.form.docNo,
                fund: this.form.fund
              }
              const result = await this.$http.get(expandURI(apiURI, expand))
              const { data } = result.data
              if (data) {
                const dataList = {
                  docHdg: data.docHdg,
                  clmNo: data.clmNo,
                  result: data.result,
                  clmtNo: this.form.clmtNo,
                  clmItem: this.form.clmItem,
                  serProvider: this.form.serProvider,
                  clmResCat: this.form.clmResCat,
                  branch: this.form.branch,
                  tranType1: this.form.tranType1,
                  docNo: this.form.docNo,
                  fund: this.form.fund
                }
                this.findClmDocList.push(dataList)
              }
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          return false
        }
        return true
      }
    },
    // find clmDoc for 628
    async find628ClmDoc(fdata) {
      const apiURI = this.getMenu.findClaimDocuments
      if (apiURI) {
        try {
          for (var j = 0; j < fdata.length; j++) {
            if (fdata[j].result === true) {
              const expand = {
                docHdg: fdata[j].docNo,
                clmNo: this.commonInfo.clmNo,
                polType: fdata[j].polType,
                clmtNo: this.claimantNo,
                clmItem: this.form.clmItem,
                serProvider: this.form.serProvider,
                clmResCat: this.form.clmResCat,
                branch: this.form.branch,
                tranType1: this.form.tranType1,
                docNo: this.form.docNo,
                fund: this.form.fund
              }
              const result = await this.$http.get(expandURI(apiURI, expand))
              const { data } = result.data
              if (data) {
                const dataList = {
                  docHdg: data.docHdg,
                  clmNo: data.clmNo,
                  result: data.result,
                  clmtNo: this.claimantNo,
                  clmItem: this.form.clmItem,
                  serProvider: this.form.serProvider,
                  clmResCat: this.form.clmResCat,
                  branch: this.form.branch,
                  tranType1: this.form.tranType1,
                  docNo: this.form.docNo,
                  fund: this.form.fund
                }
                this.findClmDocList.push(dataList)
              }
              return true
            } else {
              return false
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          return false
        }
      }
    },
    async getEmailSmsAgtByAgent() {
      const apiURI = this.getMenu.getEmailSmsAgtByAgent
      if (apiURI) {
        try {
          const expand = {
            agent: this.commonInfo.agent
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.getAgentEmail = data.agentEmail
            this.getAgentSms = data.agentSms
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getEmailMobileByPolNo() {
      const apiURI = this.getMenu.getEmailMobileByPolNo
      if (apiURI) {
        try {
          const expand = {
            polNo: this.commonInfo.polNo,
            renCnt: this.commonInfo.renCnt,
            endtCnt: this.commonInfo.endtCnt
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.getEmail = data.email
            this.getMobile = data.mobile
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getTop1ClmtDet() {
      const apiURI = this.getMenu.getTop1ClmtDet
      if (apiURI) {
        try {
          const expand = {
            clmNo: this.commonInfo.clmNo,
            clmtNo: this.claimantNo
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.clmtDetForm.clmNo = data.dto.clmNo
            this.clmtDetForm.clmtNo = data.dto.clmtNo
            this.clmtDetForm.clmtName = data.dto.clmtName
            this.clmtDetForm.addr1 = data.dto.addr1
            this.clmtDetForm.addr2 = data.dto.addr2
            this.clmtDetForm.addr3 = data.dto.addr3
            this.clmtDetForm.addr4 = data.dto.addr4
            this.clmtDetForm.postCode = data.dto.postCode
            this.clmtDetForm.email = data.dto.email
            this.clmtDetForm.mobile = data.dto.mobile
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    // create clmDoc
    async doCreate(dta) {
      const apiURI = this.getMenu.createClmDoc
      if (apiURI) {
        try {
          for (var k = 0; k < dta.length; k++) {
            if ((dta[k].docHdg === '620' || dta[k].docHdg === '622') && dta[k].result === false) {
              const expand = {
                docHdg: dta[k].docHdg,
                clmNo: this.commonInfo.clmNo,
                clmtNo: this.form.clmtNo,
                clmItem: this.form.clmItem,
                inter: this.form.serProvider,
                clmResCat: this.form.clmResCat,
                branch: this.form.branch,
                tranType1: this.form.tranType1,
                docNo: this.form.docNo,
                fund: this.form.fund
              }
              const result = await this.$http.post(apiURI, expand)
              const { data } = result
              if (data) {
                this.notify(data)
                this.message(data)
                this.fieldMessage(data)
              }
            } else if (dta[k].docHdg === '628' && dta[k].result === false) {
              const expand = {
                docHdg: dta[k].docHdg,
                clmNo: this.commonInfo.clmNo,
                clmtNo: this.claimantNo,
                clmItem: this.form.clmItem,
                inter: this.form.serProvider,
                clmResCat: this.form.clmResCat,
                branch: this.form.branch,
                tranType1: this.form.tranType1,
                docNo: this.form.docNo,
                fund: this.form.fund
              }
              const result = await this.$http.post(apiURI, expand)
              const { data } = result
              if (data) {
                this.notify(data)
                this.message(data)
                this.fieldMessage(data)
              }
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          return false
        }
        return true
      }
    },
    async fetchData(options) {
      const apiUrl = this.getMenu.getClmDoctList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            clmNo: this.commonInfo.clmNo,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filter, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.itemsList = []
            if (data) {
              data.map(datamap => {
                const convertList = {
                  tranId: datamap.tranId,
                  docHdg: datamap.docHdg,
                  docHdgDesc: this.filterDocHdgNo(datamap.docHdg),
                  clmNo: datamap.clmNo,
                  clmtNo: datamap.clmtNo,
                  clmItem: datamap.clmItem,
                  inter: datamap.inter === undefined ? '' : datamap.inter,
                  clmResCat: datamap.clmResCat === undefined ? '' : datamap.clmResCat,
                  branch: datamap.branch === undefined ? '' : datamap.branch,
                  tranType1: datamap.tranType1 === undefined ? '' : datamap.tranType1,
                  docNo: datamap.docNo === undefined ? '' : datamap.docNo,
                  genDoc: datamap.genDoc,
                  emailRecip: datamap.emailRecip,
                  smsRecip: datamap.smsRecip,
                  emailAgt: datamap.emailAgt,
                  smsAgt: datamap.smsAgt,
                  genDate: datamap.genDate,
                  genBy: datamap.genBy === '0' ? '' : datamap.genBy,
                  sentDate: datamap.sentDate,
                  sentBy: datamap.sentBy === '0' ? '' : datamap.sentBy,
                  recvDate: datamap.recvDate,
                  recvBy: datamap.recvBy === '0' ? '' : datamap.recvBy,
                  delDoc: datamap.delDoc,
                  createdBy: datamap.createdBy,
                  createdDate: datamap.createdDate,
                  modifiedBy: datamap.modifiedBy,
                  modifiedDate: datamap.modifiedDate
                }
                this.itemsList.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
          return false
        }
      }
      return true
    },
    async fetchInterList() {
      const apiUrl = this.getMenu.getInterName1List
      if (apiUrl) {
        try {
          this.interlist = []
          const result = await this.$http.get(apiUrl)
          if (result.data.dataList) {
            this.$set(this, 'interlist', result.data.dataList)
          }
        } catch (err) {
          this.interlist = []
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doPrint() {
      this.setDto().then(success1 => {
        if (success1 === true) {
          this.generateClmDoc(this.dtoList)
        }
      })
    },
    async setDto() {
      let agtEmail
      let agtSMS
      this.dtoList = []
      for (var m = 0; m < this.itemsList.length; m++) {
        // find top 1 of intermediaryMaster
        if (this.itemsList[m].emailAgt === true && this.itemsList[m].smsAgt === true) {
          agtEmail = this.getAgentEmail
          agtSMS = this.getAgentSms
        }
        // find all clmDoc
        if (this.itemsList[m].genDoc === true && this.itemsList[m].genDate === undefined && this.itemsList[m].delDoc === false) {
          if (this.itemsList[m].docHdg === '620' || this.itemsList[m].docHdg === '622') {
            const dto = {
              clmNo: this.itemsList[m].clmNo,
              agtEmail: agtEmail,
              agtSMS: agtSMS,
              clmtNo: this.itemsList[m].clmtNo,
              clmItem: this.itemsList[m].clmItem,
              inter: this.itemsList[m].inter,
              tranType1: this.itemsList[m].tranType1,
              docNo: this.itemsList[m].docNo,
              clmResCat: this.itemsList[m].clmResCat,
              docHdg: this.itemsList[m].docHdg,
              emailRecip: this.itemsList[m].emailRecip,
              smsRecip: this.itemsList[m].smsRecip,
              emailAgt: this.itemsList[m].emailAgt,
              smsAgt: this.itemsList[m].smsAgt,
              recipName1: this.commonInfo.insdName1,
              recipName2: this.commonInfo.insdName2,
              recipName3: this.commonInfo.insdName3,
              recipName4: this.commonInfo.insdName4,
              recipAdd1: this.commonInfo.insdAddr1,
              recipAdd2: this.commonInfo.insdAddr2,
              recipAdd3: this.commonInfo.insdAddr3,
              recipAdd4: this.commonInfo.insdAddr4,
              recipPostCode: this.commonInfo.postCode,
              recipEmail: this.getEmail,
              recipSms: this.getMobile,
              polType: this.commonInfo.polType
            }
            this.dtoList.push(dto)
          }
        }
      }
      return true
    },
    async generateClmDoc(vale) {
      for (var d = 0; d < vale.length; d++) {
        const apiURI = this.getMenu.exportClaimAckn
        if (apiURI) {
          try {
            this.submitting = true
            await this.$http.post(apiURI, vale[d])
            this.submitting = false
            return true
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
            this.submitting = false
            return false
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    // 628
    async set628Dto() {
      let agtEmail
      let agtSMS
      this.dtoList = []
      for (var m = 0; m < this.itemsList.length; m++) {
        // find top 1 of intermediaryMaster
        if (this.itemsList[m].emailAgt === true && this.itemsList[m].smsAgt === true) {
          agtEmail = this.getAgentEmail
          agtSMS = this.getAgentSms
        }
        // find all clmDoc
        if (this.itemsList[m].genDoc === true && this.itemsList[m].genDate === undefined && this.itemsList[m].delDoc === false) {
          if (this.itemsList[m].docHdg === '628') {
            Vue.prototype.$toast.success('Generated upon adding a Third Party Claimant. Main recipient is the TP claimant.')
            const dto = {
              clmNo: this.itemsList[m].clmNo,
              agtEmail: agtEmail,
              agtSMS: agtSMS,
              clmtNo: this.itemsList[m].clmtNo,
              clmItem: this.itemsList[m].clmItem,
              inter: this.itemsList[m].inter,
              tranType1: this.itemsList[m].tranType1,
              docNo: this.itemsList[m].docNo,
              clmResCat: this.itemsList[m].clmResCat,
              docHdg: this.itemsList[m].docHdg,
              emailRecip: this.itemsList[m].emailRecip,
              smsRecip: this.itemsList[m].smsRecip,
              emailAgt: this.itemsList[m].emailAgt,
              smsAgt: this.itemsList[m].smsAgt,
              recipName1: this.clmtDetForm.clmtName,
              recipName2: '',
              recipName3: '',
              recipName4: '',
              recipAdd1: this.clmtDetForm.addr1,
              recipAdd2: this.clmtDetForm.addr2,
              recipAdd3: this.clmtDetForm.addr3,
              recipAdd4: this.clmtDetForm.addr4,
              recipPostCode: this.clmtDetForm.postCode,
              recipEmail: this.clmtDetForm.email,
              recipSms: this.clmtDetForm.mobile
            }
            this.dtoList.push(dto)
          }
        }
      }
      return true
    },
    filterDocHdgNo(dt) {
      for (var q = 0; q < this.clmDocNoList.length; q++) {
        if (this.clmDocNoList[q].code === dt) {
          return this.clmDocNoList[q].codeValue
        }
      }
    },
    formatDisplayDate(date) {
      if (date !== undefined) {
        return formatDisplayDate(date)
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    commonAjaxMixin
  ]
}
